import React from 'react';
import { FiSearch } from 'react-icons/fi';

const SearchBox = ({ searchTerm, setSearchTerm }) => {
  return (
    <div className="search-container" style={{ position: 'relative' }}>
      <input 
        type="text" 
        className="form-control" 
        placeholder="Buscar por nome, email..." 
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        style={{ 
          paddingLeft: '32px',
          width: '250px'
        }}
      />
      <FiSearch style={{ 
        position: 'absolute', 
        left: '10px', 
        top: '50%', 
        transform: 'translateY(-50%)',
        color: 'var(--old-silver-dark)'
      }} />
    </div>
  );
};

export default SearchBox;